import { DELIVRY_NOTE_LIST_FAIL, DELIVRY_NOTE_LIST_REQUEST, DELIVRY_NOTE_LIST_SUCCESS } from "../constats/delivry_note.constant";

export const delivryNoteListReducer = (state={}, action) => {
    switch (action.type) {
        case DELIVRY_NOTE_LIST_REQUEST:
            return {
                loading: true
            };
        case DELIVRY_NOTE_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case DELIVRY_NOTE_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}